import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BreakpointsService } from '@core/services/breakpoints/breakpoints.service';
import { trackEventWithAtInternet } from '@wizbii/tracking';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-access-helps-hero',
  templateUrl: './access-helps-hero.component.html',
  styleUrls: ['./access-helps-hero.component.scss', './access-helps-hero-breakpoints.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccessHelpsHeroComponent {
  trackEvent = trackEventWithAtInternet;

  get isMobileOrTablet$(): Observable<boolean> {
    return this.breakpointsService.isMobileAndTabletPortrait$;
  }

  get isTabletLandscape$(): Observable<boolean> {
    return this.breakpointsService.isTabletLandscape$;
  }

  get isIpadPro$(): Observable<boolean> {
    return this.breakpointsService.isIpadPro$;
  }

  constructor(private readonly breakpointsService: BreakpointsService) {}
}
